// extracted by mini-css-extract-plugin
export default {"seperator":"screens_seperator__sizWa"};